import React, {PureComponent} from 'react';
import {Pagination as BPagination, PaginationItem, PaginationLink} from "reactstrap";

type PaginationType = {
    active: number
    total: number
    by: number
    paginateHandler: (number: number) => void
}

class Pagination extends PureComponent<PaginationType & React.HTMLAttributes<HTMLDivElement>> {
    render() {
        const {active, total, by, paginateHandler} = this.props;
        const pageCount = Math.ceil(total / by);

        if (pageCount <= 1) {
            return null;
        }

        const siblings = 3;
        const pages: (number | '...')[] = [];

        const rangeStart = Math.max(2, active - siblings);
        const rangeEnd = Math.min(pageCount - 1, active + siblings);

        pages.push(1);
        if (rangeStart > 2) pages.push('...');
        for (let i = rangeStart; i <= rangeEnd; i++) {
            pages.push(i);
        }
        if (rangeEnd < pageCount - 1) pages.push('...');
        if (pageCount > 1) pages.push(pageCount);

        return <BPagination>
            {active !== 1 && <PaginationItem onClick={() => paginateHandler(active - 1)}>
                <PaginationLink previous/>
            </PaginationItem>}
            {pages.map((page, index) => (
                page === '...'
                    ? <PaginationItem key={'dots-' + index} disabled>
                        <PaginationLink>&hellip;</PaginationLink>
                    </PaginationItem>
                    : <PaginationItem key={page} active={page === active} onClick={() => paginateHandler(page)}>
                        <PaginationLink>{page}</PaginationLink>
                    </PaginationItem>
            ))}
            {active !== pageCount && <PaginationItem onClick={() => paginateHandler(active + 1)}>
                <PaginationLink next/>
            </PaginationItem>}
        </BPagination>
    }
}


export default Pagination;
